import React from 'react';
import { BBA_PRIMARY, BBA_SECONDARY } from '../../themes/tokens';

interface FormHeaderLabelProps {
  label: string;
  fieldAt?: number | undefined;
  fieldMax?: number | undefined;
}

// Section header: soft light-blue strip with a primary accent bar and navy
// title. Plain markup (no UI-lib dependency) so it looks consistent under antd.
const FormHeaderLabel: React.FC<FormHeaderLabelProps> = (props) => {
  const { label, fieldAt, fieldMax } = props;
  const hasFieldSection = fieldAt && fieldMax;
  const text = hasFieldSection ? `Field(${fieldAt}/${fieldMax}): ${label}` : `${label}`;
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '12px 16px',
        background: '#EAF4FE',
        borderBottom: '1px solid #CFE6FB',
        borderRadius: '12px 12px 0 0',
      }}
    >
      <span style={{
        width: 4, height: 18, borderRadius: 4, background: BBA_PRIMARY, flexShrink: 0,
      }}
      />
      <span style={{
        color: BBA_SECONDARY, fontWeight: 700, fontSize: '0.95rem', letterSpacing: 0.2,
      }}
      >
        {text}
      </span>
    </div>
  );
};

FormHeaderLabel.defaultProps = {
  fieldAt: undefined,
  fieldMax: undefined,
};

export default FormHeaderLabel;
